/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_SubInputs */



/**
* | output |
* | --- |
* | "Manage your export and standards presets" |
*
* @param {Preset_Manager_SubInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_sub = /** @type {((inputs?: Preset_Manager_SubInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_SubInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gérez vos préréglages et paramètres d’export")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verwalten Sie Ihre Exportvorgaben und -einstellungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gestisci i tuoi preset e le impostazioni di esportazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Управляйте своими настройками и параметрами экспорта.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Administra tus ajustes y configuraciones preestablecidas de exportación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("管理您的导出预设和设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポートのプリセットと設定を管理する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपने निर्यात प्रीसेट और सेटिंग्स को प्रबंधित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gerencie suas predefinições e configurações de exportação.")
	return /** @type {LocalizedString} */ ("Manage your export and standards presets")
});